import browseFile from "../../browseFile";
import csvToJson from "../../csvToJson";
import unflatten from "../../unflatten";
import jsonToObject from "../../jsonToObject";
import BaseListPresenter from "../../base/BaseListPresenter";
import { upsertUseCase } from "../../usecases/object";

const THIRTY_MINUTES_MS = 30 * 60 * 1000;

function normalize(v) {
  return String(v || "").trim();
}

// POS number = count of leading 'A' in store_id (A... = 1, AA... = 2, AAA... = 3, etc.)
function getPosNumberFromStoreId(store_id) {
  const m = normalize(store_id).match(/^A+/);
  return m ? Math.max(1, m[0].length) : 1;
}

// Prefer tz-aware fields
function getTxTimestamp(tx) {
  const ts = tx.window || tx.deltime || tx.updated || tx.created || null;
  const d = ts ? new Date(ts) : null;
  return d && !isNaN(d.getTime()) ? d : null;
}

// Build latest tx per (store_code, posNumber)
function buildLatestTxMap(transactions) {
  const map = new Map(); // key: `${code}::${posNumber}` -> Date
  const posSeenPerStore = new Map(); // store_code -> Set(posNumber)
  for (const tx of transactions || []) {
    const code = normalize(tx.store_code);
    const when = getTxTimestamp(tx);
    const pos = getPosNumberFromStoreId(tx.store_id);
    if (!code || !when) continue;

    const key = `${code}::${pos}`;
    const prev = map.get(key);
    if (!prev || when > prev) map.set(key, when);

    if (!posSeenPerStore.has(code)) posSeenPerStore.set(code, new Set());
    posSeenPerStore.get(code).add(pos);
  }
  return { map, posSeenPerStore };
}

function statusFromDate(last, now = new Date()) {
  if (!last) return { status: "offline", minutesSince: null };
  const diffMs = now - last;
  return {
    status: diffMs <= THIRTY_MINUTES_MS ? "online" : "offline",
    minutesSince: Math.floor(diffMs / 60000),
  };
}

class StoreStatusPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase
  ) {
    super(view, findObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
  }

  componentDidUpdate(prevProps) {
    const prevClassName = prevProps.params.name;
    const newClassName = this.view.getCollectionName();
    //if collection change
    if (prevClassName !== newClassName) {
      this.init();
      this.getObjects();
    }
  }

  // async getObjects() {
  //   const collection = "storeAnalytics";
  //   const collection2 = "transactions";
  //   const skip = (this.current - 1) * this.limit;

  //   const query = {
  //     count: true,
  //     limit: this.limit,
  //     skip,
  //     where: this.where,
  //     include: ["all"],
  //     sort: this.sort,
  //   };

  //   const now = new Date();

  //   // First day of the current month (local time)
  //   const firstOfCurrentMonth = new Date(now.getFullYear(), now.getMonth(), 1);

  //   // First day of the previous month (local time)
  //   const firstOfPrevMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);

  //   // Start: 5:00 AM on the first day of the previous month
  //   const startOfBusinessDay = new Date(firstOfPrevMonth);
  //   startOfBusinessDay.setHours(5, 0, 0, 0);

  //   // End: 4:59:59.999 AM on the first day of the current month
  //   const endOfBusinessDay = new Date(now);
  //   endOfBusinessDay.setDate(endOfBusinessDay.getDate() + 1);
  //   endOfBusinessDay.setHours(4, 59, 59, 999);

  //   console.log("startOfBusinessDay", startOfBusinessDay);

  //   const query2 = {
  //     count: true,
  //     limit: 150000,
  //     skip: (this.current - 1) * this.limit,
  //     where: {
  //       tran_date: {
  //         $gte: startOfBusinessDay,
  //         $lte: endOfBusinessDay,
  //       },
  //     },
  //     include: ["all"],
  //     sort: { tran_date: -1 },
  //     keys: ["store_code", "store_id", "tran_date"],
  //   };

  //   this.view.showProgressDialog();

  //   const onData = (objects) => {
  //     const transactions = objects;

  //   };
  //   try {
  //     const stores = await this.findObjectUseCase.execute(collection, query);
  //     const transactions = await this.findObjectUseCase.execute(
  //       collection2,
  //       query2,
  //       { timeout: 120000, onData }
  //     );

  //     console.log("store", stores);
  //     console.log("transact", transactions);

  //     // Build a map of latest transaction per store and POS
  //     const latestTxMap = new Map(); // key: "storeName::posId" -> latest transaction date

  //     transactions.forEach((tx) => {
  //       const storeCode = tx.store_code;
  //       const storeId = tx.store_id;
  //       const tranDate = new Date(tx.tran_date);

  //       const key = `${storeCode}::${storeId}`;
  //       const existing = latestTxMap.get(key);

  //       if (!existing || tranDate > existing) {
  //         latestTxMap.set(key, tranDate);
  //       }
  //     });

  //     const enriched = stores.map((store) => {
  //       const storeName = store.name;

  //       // Get all POS IDs from pos1 to pos5
  //       const posFields = ["pos1", "pos2", "pos3", "pos4", "pos5"];
  //       const posStatuses = [];

  //       posFields.forEach((posField, index) => {
  //         const posId = store[posField];

  //         // Only check if POS ID exists and is not empty
  //         if (posId && posId.trim() !== "") {
  //           const key = `${storeName}::${posId}`;
  //           const lastTxDate = latestTxMap.get(key);

  //           let status = "offline";
  //           let minutesSince = null;

  //           if (lastTxDate) {
  //             const diffMs = now - lastTxDate;
  //             minutesSince = Math.floor(diffMs / 60000);

  //             // Consider online if last transaction was within 30 minutes
  //             status = minutesSince <= 30 ? "online" : "offline";
  //           }

  //           posStatuses.push({
  //             posNumber: index + 1,
  //             posId: posId,
  //             posField: posField,
  //             lastTransactionAt: lastTxDate ? lastTxDate.toISOString() : null,
  //             minutesSinceLastTransaction: minutesSince,
  //             status,
  //           });
  //         }
  //       });

  //       // Overall store status = online if ANY POS is online
  //       const overall = posStatuses.some((p) => p.status === "online")
  //         ? "online"
  //         : "offline";

  //       return {
  //         ...store,
  //         status: overall,
  //         posStatuses,
  //       };
  //     });

  //     this.objects = this.objects.concat(enriched);
  //     console.log("this.objects", this.objects);
  //     this.view.setObjects(this.objects);
  //     this.view.hideProgressDialog();
  //   } catch (error) {
  //     this.view.hideProgress();
  //     this.view.showError(error);
  //   }
  // }

  async getObjects() {
    const collection = "storeAnalytics";
    const collection2 = "transactions";
    const skip = (this.current - 1) * this.limit;

    const query = {
      count: true,
      limit: this.limit,
      skip,
      where: this.where,
      include: ["all"],
      sort: this.sort,
    };

    const now = new Date();

    // Window: from 5:00 AM of the FIRST DAY of previous month
    // to 4:59:59.999 AM of the FIRST DAY of current month (local time).
    const firstOfCurrentMonth = new Date(now.getFullYear(), now.getMonth(), 1);
    const firstOfPrevMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);

    const startOfBusinessDay = new Date(firstOfPrevMonth);
    startOfBusinessDay.setHours(5, 0, 0, 0);

    // const endOfBusinessDay = new Date(firstOfCurrentMonth);
    // endOfBusinessDay.setHours(4, 59, 59, 999);
    const endOfBusinessDay = new Date(now);
    endOfBusinessDay.setDate(endOfBusinessDay.getDate() + 1);
    endOfBusinessDay.setHours(4, 59, 59, 999);

    // Map of latest transaction date per "store_code::posId"
    const latestTxMap = new Map();

    // Helper: update map with a transaction record
    const considerTx = (tx) => {
      if (!tx) return;

      // console.log("tx", tx);
      const storeCode = tx.store_code || tx.storeCode || tx.store?.code;
      const posId = tx.store_id || tx.pos_id || tx.posId; // adjust to actual field carrying POS terminal id

      if (!storeCode || !posId || !tx.tran_date) return;

      const key = `${String(storeCode)}::${String(posId)}`;
      const tranDate = new Date(tx.tran_date);
      const existing = latestTxMap.get(key);
      if (!existing || tranDate > existing) {
        latestTxMap.set(key, tranDate);
      }
    };

    // Stream handler: called for each chunk/page/batch
    const onData = (batch) => {
      if (!Array.isArray(batch)) return;
      for (const tx of batch) considerTx(tx);
      // (Optional) You can surface partial progress here if your view supports it.
      // this.view.updateProgress(`Processed ${latestTxMap.size} POS keys so far…`);
    };

    const query2 = {
      count: true,
      // limit: 30000, // server decides batch size; onData will be called per chunk
      skip: 0, // for streaming, skip=0 and let backend page internally
      where: {
        tran_date: { $gte: startOfBusinessDay, $lte: endOfBusinessDay },
      },
      include: ["all"],
      sort: { tran_date: -1 },
      keys: ["store_code", "store_id", "tran_date"], // keep narrow to reduce payload
    };

    this.view.showProgressDialog();

    try {
      // 1) Fetch current page of stores (lightweight)
      const stores = await this.findObjectUseCase.execute(collection, query);

      // 2) Stream transactions; we ignore return value and rely on onData.
      const trans = await this.findObjectUseCase.execute(collection2, query2, {
        timeout: 120000,
        onData,
      });

      console.log("trans", trans);

      // 3) Enrich stores using the *correct* key: store_code (NOT name) + each posId
      const enriched = stores.map((store) => {
        // Prefer a code used by transactions (e.g., tx.store_code)
        const storeCode =
          store.code || store.store_code || store.storeCode || store.name; // last fallback if your data truly uses name as code

        const posFields = ["pos1", "pos2", "pos3", "pos4", "pos5"];
        const posStatuses = [];

        for (let i = 0; i < posFields.length; i++) {
          const posField = posFields[i];
          const rawPosId = store[posField];

          // Only check if POS ID exists and is not empty
          if (rawPosId != null && String(rawPosId).trim() !== "") {
            const posId = String(rawPosId).trim();
            const key = `${String(storeCode)}::${posId}`;
            const lastTxDate = latestTxMap.get(key);

            let status = "offline";
            let minutesSince = null;

            if (lastTxDate) {
              const diffMs = now - lastTxDate;
              minutesSince = Math.floor(diffMs / 60000);
              status = minutesSince <= 30 ? "online" : "offline";
            }

            posStatuses.push({
              posNumber: i + 1,
              posId,
              posField,
              lastTransactionAt: lastTxDate ? lastTxDate.toISOString() : null,
              minutesSinceLastTransaction: minutesSince,
              status,
            });
          }
        }

        const overall = posStatuses.some((p) => p.status === "online")
          ? "online"
          : "offline";

        return {
          ...store,
          status: overall,
          posStatuses,
        };
      });

      // If you’re paginating stores, append; otherwise replace.
      this.objects = this.objects.concat(enriched);
      this.view.setObjects(this.objects);
      this.view.hideProgressDialog();
    } catch (error) {
      this.view.hideProgressDialog(); // keep consistent
      this.view.showError(error);
    }
  }

  onClickImport() {
    const schema = this.view.getSchema(this.view.getCollectionName());
    browseFile("text/csv")
      .then((files) => csvToJson(files[0]))
      .then((objects) => unflatten(objects))
      .then((objects) => objects.map((o) => jsonToObject(o, schema.fields)))
      .then(async (objects) => {
        for (const obj of objects) {
          const object = await this.upsertUseCase.execute(
            schema.collection,
            obj
          );
          this.objects.push(object);
          this.view.setObjects(this.objects);
        }
      })
      .catch((error) => {
        this.view.hideProgress();
        this.view.showError(error);
      });
  }

  onClickExport() {
    const objects = this.view.getSelected();
    const collection = this.view.getCollectionName();
    this.exportCSVUseCase.execute(objects, collection).then(() => {
      //hide progress
    });
  }

  onSubmitDeleteField(field) {
    const collection = this.view.getCollectionName();
    const schema = this.view.getSchema(collection);
    delete schema["fields"][field];
    this.updateSchemaUseCase
      .execute(schema)
      .then(() => {
        this.view.forceUpdate();
        this.view.closeDialog();
      })
      .catch((error) => {
        this.view.showError(error);
      });
  }

  onSubmitAddCollection(schema) {
    this.view.closeDialog();
    this.addSchemaUseCase
      .execute(schema)
      .then((schema) => {
        const schemas = this.view.getSchemas();
        schemas.push(schema);
        this.view.setSchemas(schemas);
        this.view.navigateTo("/collection/" + schema.collection);
      })
      .catch((error) => {
        this.view.showError(error);
      });
  }

  onSubmitEditCollection(schema) {
    this.view.closeDialog();
    this.updateSchemaUseCase
      .execute(schema)
      .then((schema) => {
        const schemas = this.view.getSchemas();
        const index = schemas.findIndex(
          (s) => s.collection === schema.collection
        );
        schemas[index] = schema;
        this.view.setSchemas(schemas);
      })
      .catch((error) => {
        this.view.showError(error);
      });
  }

  onSubmitDeleteCollection(collection) {
    if (collection !== this.view.getCollectionName()) {
      this.view.closeDialog();
      this.view.showError("Please enter correct Class name");
      return;
    }
    this.deleteSchemaUseCase
      .execute(collection)
      .then(() => {
        this.view.closeDialog();
        const schemas = this.view.getSchemas();
        const index = schemas.findIndex((s) => s.collection === collection);
        schemas.splice(index, 1);
        this.view.setSchemas(schemas);
        this.view.navigateTo("/collection/" + schemas[0].collection);
      })
      .catch((error) => {
        this.view.closeDialog();
        this.view.showError(error);
      });
  }

  onSubmitAccess(acl) {
    const selected = this.view.getSelected();
    const collection = this.view.getCollectionName();
    const promises = selected.map((o) => {
      const change = { id: o.id, acl };
      o.acl = acl; // mutate the object
      return this.upsertUseCase.execute(collection, change);
    });
    Promise.all(promises)
      .then(() => {
        this.view.closeDialog();
      })
      .catch((error) => {
        this.view.closeDialog();
        this.view.showError(error);
      });
  }

  // async onDisabled() {
  //   const selected = this.view.getSelected();
  //   const collection = this.view.getCollectionName();
  //   try {
  //     await this.view.showDialog({
  //       title: "Disable Data?",
  //       message: "Are you sure you want to disable?",
  //     });
  //     for (const obj of selected) {
  //       obj.statusDisabled = true;
  //       await upsertUseCase().execute(collection, obj);
  //       const index = this.objects.indexOf(obj);
  //       // this.objects.splice(index, 1);
  //       this.view.setObjects(this.objects);
  //     }
  //     this.view.setSelected([]);
  //   } catch (error) {
  //     this.view.hideProgress();
  //     this.view.showError(error);
  //   }
  // }
  async onDisabled() {
    const selected = this.view.getSelected();
    const collection = this.view.getCollectionName();
    try {
      await this.view.showDialog({
        title: "Toggle Data Status?",
        message: "Are you sure you want to toggle the status?",
      });
      for (const obj of selected) {
        // Toggle the statusDisabled value
        obj.statusDisabled = !obj.statusDisabled; // Flip the value (true <-> false)
        await upsertUseCase().execute(collection, obj);
        const index = this.objects.indexOf(obj);
        // this.objects.splice(index, 1);
        this.view.setObjects(this.objects);
      }
      this.view.setSelected([]);
    } catch (error) {
      this.view.hideProgress();
      this.view.showError(error);
    }
  }
}

export default StoreStatusPresenter;
